<template lang="pug">
  .main-chair
    .title
      h1.title-logo
        a.title-logo-image(href='./'): img(src='@/assets/image/logo.svg' alt='Serio Mμ')
        a.title-logo-modelR(href='./' v-if="isCurrentModelMuR"): img.title-logo-modelR-image(src='@/assets/image/logo_MuR.svg' alt='Serio Mμ')
      .title-heading
        h3.title-heading-wrap
          img.title-heading-word(:src="require(`@/assets/image/color_simulator.svg`)" alt='COLOR SIMULATOR')
    color-status(v-if="isSp")
    .explain 
      .explain-seat(v-if="!isCurrentModelMuR")
        p.explain-seat-word 前折れステップ 1型 標準シート仕様
        p.explain-seat-word-sub ※標準シートのみ対応可
      .explain-seat(v-if="isCurrentModelMuR")
        p.explain-seat-word カンター 1型 Fukka-Fukaシート仕様
        p.explain-seat-word-sub ※Fukka-Fukaシート色のみ対応可
    .swiper(ref="mySwiper")
      .swiper-wrapper
        .swiper-slide.main-chair-view(v-for="model in getAllModels" :ref="model" :data-type='model')
          .img-back(v-if="!isModelMuR(model)"): img(src='@/assets/image/yuka.png')
          .img-back(v-if="isModelMuR(model)"): img(src='@/assets/image/yuka_MuR.png')
          .unit
            template(v-for="image in units(model)")
              transition(name='view')
                .img-main(v-if="isCurrentUnit(image)" :class='{ active: isCurrentUnit(image), "img-main-mur": isModelMuR(model) }'): img(:src="image.file")
          .seat
            template(v-for="image in seats(model)")
              transition(name='view')
                .img-main(
                  v-if="isCurrentSeat(image)"
                  :class='{ active : isCurrentSeat(image), "img-main-mur": isModelMuR(model)}'
                ): img(:src="image.file")
      .swiper-pagination
      .swiper-button-prev
      .swiper-button-next
</template>
<script>
import SelectStatus from '@/components/SelectStatus.vue';
import { mapGetters, mapActions } from 'vuex';
import Swiper, { Navigation, Pagination, Keyboard } from 'swiper';
import 'swiper/swiper-bundle.css';
import { forEach } from 'lodash';
import Utils from '@/assets/js/Utils';
export default {
  // 画像表示箇所
  name: 'SelectView',
  components: {
    'color-status': SelectStatus,
  },
  mounted() {
    this.swiperObject = new Swiper(this.$refs.mySwiper, this.swiperOptions);
  },
  data() {
    return {
      swiperObject: null,
      swiperOptions: {
        modules: [Navigation, Pagination, Keyboard],
        loop: true,
        slidesPerView: 1,
        speed: 500,
        on: {
          slideNextTransitionStart: async (swiper) => {
            this.setModel(this.getAllModels[swiper.realIndex]);
          },
          slideNextTransitionEnd: async (swiper) => {
            // 初回起動時にも実行されるのでスキップ
            if (swiper.activeIndex - swiper.realIndex === 1) return;
            swiper.slideToLoop(1, 0);
          },
          slidePrevTransitionStart: async (swiper) => {
            this.setModel(this.getAllModels[swiper.realIndex]);
          },
          slidePrevTransitionEnd: async (swiper) => {
            if (swiper.realIndex - swiper.activeIndex === 1) return;
            swiper.slideToLoop(0, 0);
          },
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      'getColorsArray',
      'isCurrentUnit',
      'isCurrentSeat',
      'isSp',
      'getAllModels',
      'getCurrentModel',
      'currentUnitCode',
      'currentSeatCode',
    ]),
    realIndex() {
      return this.swiperObject.realIndex;
    },
    units() {
      return function (model) {
        return this.getColorsArray.filter(
          (item) => item.model === model && item.type === 'unit'
        );
      };
    },
    seats() {
      return function (model) {
        return this.getColorsArray.filter(
          (item) => item.model === model && item.type === 'seat'
        );
      };
    },
    swiper() {
      return this.$refs.mySwiper;
    },
    isCurrentModelMuR() {
      return this.getCurrentModel === 'MuR';
    },
  },
  methods: {
    ...mapActions(['setModel']),
    isModelMuR(model) {
      return model === 'MuR';
    },
    cloneElements() {
      const slideA = this.$refs.Mu;
      const slideB = this.$refs.MuR;
      const allSlide = this.swiperObject.slides;
      forEach(allSlide, ($target) => {
        const str = $target.innerHTML;
        const type = $target.dataset.type;
        if (type === 'Mu') {
          if (str !== slideA[0].innerHTML)
            $target.innerHTML = slideA[0].innerHTML;
        }
        if (type === 'MuR') {
          if (str !== slideB[0].innerHTML)
            $target.innerHTML = slideB[0].innerHTML;
        }
      });
      Utils.clearWait();
    },
  },
  watch: {
    async currentUnitCode() {
      await Utils.wait(300);
      this.swiperObject.slideToLoop(this.realIndex, 0);
      this.cloneElements();
    },
    async currentSeatCode() {
      await Utils.wait(300);
      this.swiperObject.slideToLoop(this.realIndex, 0);
      this.cloneElements();
    },
  },
};
</script>
<style lang="scss" scoped>
.main-chair {
  position: relative;
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: calc(100% - 298px);
  background: linear-gradient(
    152deg,
    #c0cde2 0%,
    #c1cfe1 49%,
    #c1cfe1 50%,
    #dee6f1 51%,
    #e3e9f4 100%
  );

  .title {
    position: absolute;
    top: 38px;
    left: 34px;
    z-index: 333;

    &-logo {
      z-index: 1;
      display: flex;
      width: 100%;

      &-image {
        display: block;

        img {
          width: 100%;
        }
      }

      &-modelR {
        margin-left: 2px;
      }
    }

    &-heading {
      &-wrap {
        width: 253px;
      }

      &-word {
        width: 100%;
      }
    }
  }

  &-view {
    position: relative;
    width: 100%;

    .img {
      position: absolute;
      top: 0;
      top: 50%;
      left: 0;
      left: 50%;
      transform: translate(-50%, -50%);

      img {
        width: 100%;
      }
    }

    .img-back {
      @extend .img;

      width: 119%;
      height: auto;
    }

    .img-main {
      @extend .img;

      width: 63.3%;
      height: auto;
      transform: translate(-54.7%, -52.1%);

      &-mur {
        width: 72.3%;
        transform: translate(-49.6%, -51.3%);
      }

      &.active {
        z-index: 2;
      }
    }
  }

  .explain {
    @extend %notosans-bold;

    position: absolute;
    top: 128px;
    left: 34px;
    z-index: 333;

    &-seat {
      &-word {
        margin-bottom: 5px;
        font-size: 14px;

        &-sub {
          font-size: 12px;
        }
      }
    }
  }

  .swiper {
    width: 100%;
    height: 100%;

    &-wrapper {
      .swiper-slide-active {
        z-index: 999;
      }
    }

    &-button {
      &-prev,
      &-next {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        background: rgba(255, 255, 255, 60%);
        border-radius: 50%;

        &::before {
          position: absolute;
          top: 17px;
          display: inline-block;
          width: 15px;
          height: 5px;
          content: '';
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        &::after {
          content: '';
        }
      }

      &-prev {
        margin-left: 25px;

        &::before {
          background-image: url('../assets/image/arrow_left.svg');
        }
      }

      &-next {
        margin-right: 25px;

        &::before {
          background-image: url('../assets/image/arrow_right.svg');
        }
      }
    }

    &-pagination {
      bottom: 76px;

      ::v-deep .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        background-color: #bebebe;
        border: 1px solid #707070;
        border-radius: 50%;
        opacity: 1;

        &-active {
          background-color: #fff;
        }
      }
    }
  }
}

.unit {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.seat {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
}
@include pc-layout {
  .main-chair {
    .title {
      a {
        opacity: 1;
        will-change: opacity;
        transition: opacity 250ms ease-in-out;

        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}
@include sp-layout {
  .main-chair {
    flex: 1;
    width: 100%;
    height: calc(100% - #{vw(430)});

    .title {
      top: vw(34);
      left: vw(34);

      &-logo {
        &-image {
          width: vw(248);
        }

        &-modelR {
          margin-left: vw(2);

          &-image {
            width: vw(58);
            height: vw(38);
          }
        }
      }

      &-heading {
        &-wrap {
          width: vw(282);
        }
      }
    }

    &-view {
      width: 100%;
      min-width: auto;
      margin-top: vw(150);

      $img_back_width: calc(100vw + 300px);

      .img-back {
        width: $img_back_width;
        transform: translate(-47%, -60%);
        object-fit: cover;
      }

      .img-main {
        width: 100%;
        width: calc(#{$img_back_width} * 0.533);
        height: initial;
        transform: translate(-49%, -68.7%);
        object-fit: cover;

        &-mur {
          width: 109%;
          transform: translate(-44.6%, -68.2%);
        }
      }
    }

    .explain {
      top: vw(228);
      left: vw(34);
      font-weight: 500;

      &-seat {
        &-word {
          font-size: vw(18);

          &-sub {
            font-size: vw(18);
          }
        }
      }
    }

    .swiper {
      &-button {
        &-prev,
        &-next {
          top: auto;
          bottom: vw(20);
          width: vw(70);
          height: vw(70);

          &::before {
            top: vw(26);
            width: vw(22);
            height: vw(12);
          }
        }

        &-prev {
          margin-left: 0;
        }

        &-next {
          margin-right: 0;
        }
      }

      &-pagination {
        bottom: vw(34);

        ::v-deep .swiper-pagination-bullet {
          width: vw(16);
          height: vw(16);
        }
      }
    }
  }
}
</style>
